export default __webpack_public_path__ + "static/media/049-greeting card.beafc7e5.svg";